import { Query } from '@tanstack/react-query'
import { QueryMetaType } from 'types/reactQuery'

export const onQuerySuccess = (data: unknown, query: Query) => {
  const { onSuccess } = (query?.meta as QueryMetaType) || {}
  onSuccess && onSuccess(data)
}
